import React from 'react';
import Button3 from './ui/Button3';
import Button4 from './ui/Button4';
import ArrowIconWhite from '../assets/icons/ArrowIconWhite.svg';
import { useNavigate } from 'react-router-dom';

const FooterCTA = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col lg:flex-row max-w-6xl w-[95%] mx-auto bg-jbsBlue justify-between items-center rounded-[40px] px-6 sm:px-10 lg:pl-28 lg:pr-12 py-12 lg:py-6 relative z-10 gap-8 lg:gap-0">

      {/* Left Side */}
      <div className="flex flex-col gap-4 text-center lg:text-left w-full lg:w-3/5">
        <h1 className="text-white font-bold text-[32px] sm:text-[40px] lg:text-[48px] leading-tight tracking-[-0.03em]">
          Ready to shape <br className="hidden sm:block" /> the future with us?
        </h1>
        <p className="text-white font-extralight text-[16px] sm:text-[18px] lg:text-[20px] tracking-[-0.02em]">
          Let’s build a smarter world together — whether you're looking to collaborate, invest, or bring automation to your industry.
        </p>

        <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3 sm:gap-x-4">
          <Button3 onClick={() => navigate('/invest')} width="240px">INVEST IN INNOVATION</Button3>
          <Button4 onClick={() => navigate('/contact')} width="240px">CONTACT US</Button4>
        </div>
      </div>

      {/* Right Side */}
      <div className="border-[5px] border-white p-6 sm:p-8 rounded-[28px] sm:rounded-[38px]">
  <img 
    src={ArrowIconWhite} 
    alt="Arrow Icon" 
    className="w-10 sm:w-full " // 👈 smaller on mobile, bigger on larger screens
  />
</div>

    </div>
  );
};

export default FooterCTA;
